export default __webpack_public_path__ + "static/media/success.9dc12531.m4r";